import styled from 'styled-components';
import { FlexColumn, Input } from '@make-software/cspr-design';
import React, { useState } from 'react';
import { formatDate, parseDate } from 'app/components/utils/date-time';
import { DayPicker } from 'react-day-picker';
import { AutomationTypeControlProps } from 'app/components/common/automation/utils';
import { DateParams } from 'app/console-api/automations/types';
import { ErrorText, ErrorTextContainer } from 'app/components/common/common-styles';

const CalendarContent = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    width: '100%',
    marginTop: '8px',
    marginLeft: '8px'
  })
);

const DayPickerWrapper = styled.div(({ theme }) =>
  theme.withMedia({
    '.rdp-root': {
      '--rdp-accent-color': theme.styleguideColors.contentLightBlue,
      '--rdp-accent-background-color': `${theme.styleguideColors.contentLightBlue}26`,
      '.rdp-button_previous, .rdp-button_next': {
        backgroundColor: theme.styleguideColors.fillSecondary,
        borderRadius: '50%',
        marginLeft: 10,
        svg: {
          height: '16px',
          fill: 'black'
        }
      }
    }
  })
);

export const DateControl = ({ value, onChange, errors }: AutomationTypeControlProps) => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const startParam = parseDate((value as DateParams).at) || new Date();
  const [calendarValue, setCalendarValue] = useState(startParam);
  const [inputValue, setInputValue] = useState(formatDate(startParam));

  const handleDaySelect = (date: Date) => {
    setCalendarValue(date || startParam);
    setInputValue(formatDate(date));
    setIsCalendarOpen(false);
    onChange({
      ...value,
      at: formatDate(date)
    });
  };
  return (
    <FlexColumn>
      <Input
        value={inputValue}
        disabled={false}
        placeholder="Select Date"
        onClick={() => setIsCalendarOpen(!isCalendarOpen)}
      />
      {isCalendarOpen && (
        <CalendarContent>
          <DayPickerWrapper>
            <DayPicker
              mode="single"
              selected={calendarValue}
              onSelect={handleDaySelect}
              required
              disabled={[{ before: startParam }]}
            />
          </DayPickerWrapper>
        </CalendarContent>
      )}
      {errors?.at && (
        <ErrorTextContainer justify={'flex-start'} top={'46px'}>
          <ErrorText size={3}>{errors?.at?.message}</ErrorText>
        </ErrorTextContainer>
      )}
    </FlexColumn>
  );
};
